import React, {Component} from 'react';

export default class Hotspot extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            hotspotClasses,
            id,
            style,
            onClick,
            onMouseEnter,
            onMouseLeave,
            labelText
        } = this.props;

        return (
            <div className={hotspotClasses}
                 id={id}
                 style={style}
                 onClick={onClick}
                 onMouseEnter={onMouseEnter || null}
                 onMouseLeave={onMouseLeave || null}
            >
                <span className="hotspot__marker"/>
                <div className="hotspot__line-container">
                    <span className="hotspot__line"/>
                </div>
                <div className="hotspot__label-container">
                    <div className="hotspot__label">
                        <span className="hotspot__label-text">{labelText}</span>
                    </div>
                </div>
            </div>
        )
    }
}